import React from "react";

type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

const Input: React.FC<InputProps> = ({ className, ...props }) => {
  const baseClasses = [
    "w-full bg-bg rounded-xl",
    "border-0 outline-none",
    "py-[0.8125rem] px-4",
    "text-[1.0625rem] leading-[1.375rem] text-text placeholder:text-secondary-hint",
  ].join(" ");

  return <input className={`${baseClasses} ${className}`} {...props} />;
};

export default Input;
